/* Full width slider */
$(function () {
    $(".slider .slider-items").each(function () {
        var thisElement = $(this);
        thisElement.slick({
            fade: true,
            dots: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: thisElement.closest('.slider').find('.sliderPrevButton'),
            nextArrow: thisElement.closest('.slider').find('.sliderNextButton'),
            mobileFirst: true,
            responsive: [{
                breakpoint: 992,
                settings: {
                    slidesToShow: 1
                }
            }, ]
        });
    })
});

/* Related news slider */
$(function () {
    $(".related-news .slider-items").each(function () {
        var thisElement = $(this);
        thisElement.slick({
            dots: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 600,
            draggable: true,
            prevArrow: thisElement.closest('.related-news-slider').find('.sliderPrevButton'),
            nextArrow: thisElement.closest('.related-news-slider').find('.sliderNextButton'),
            variableWidth: true,
            centerMode: true,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        variableWidth: false,
                        centerMode: false,
                        slidesToShow: 2
                    }
                }, 
                {
                    breakpoint: 992,
                    settings: {
                        variableWidth: false,
                        centerMode: false,
                        slidesToShow: 3
                    }
                }, 
                {
                    breakpoint: 1200,
                    settings: {
                        variableWidth: false,
                        centerMode: false,
                        draggable: false,
                        slidesToShow: 4
                    }
                }, 
                {
                    breakpoint: 1400,
                    settings: {
                        variableWidth: false,
                        centerMode: false,
                        draggable: false,
                        slidesToShow: 4
                    }
                }
            ]
        });
    })
});

/* Related projects slider */
$(function () {
    $(".related-projects .slider-items").each(function () {
        var thisElement = $(this);
        thisElement.slick({
            dots: false,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 600,
            draggable: true,
            prevArrow: thisElement.closest('.related-projects-slider').find('.sliderPrevButton'),
            nextArrow: thisElement.closest('.related-projects-slider').find('.sliderNextButton'),
            variableWidth: true,
            centerMode: true,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        variableWidth: false,
                        centerMode: true,
                        slidesToShow: 1
                    }
                }, 
                {
                    breakpoint: 992,
                    settings: {
                        variableWidth: false,
                        centerMode: false,
                        slidesToShow: 2
                    }
                }, 
                {
                    breakpoint: 1300,
                    settings: {
                        variableWidth: false,
                        centerMode: false,
                        draggable: false,
                        slidesToShow: 3
                    }
                }
            ]
        });
    })
});


/* Video modal */
$(function () {
    $(".video").each(function () {
        var thisBlock = $(this);
        var altVideoSrc = $(this).data('mfp-src');
        if (altVideoSrc.includes('https://youtu.be')) {
            var newStr = altVideoSrc.split('https://youtu.be/')[1];
            var newYoutubeUrl = 'https://www.youtube.com/watch?v=' + newStr;
            $(this).attr('data-mfp-src', newYoutubeUrl);
        }
        $(this).magnificPopup({
            type: "iframe",
            removalDelay: 160,
            preloader: !1,
            fixedContentPos: !1
        })
    });
});
